<template>
    <div class="lsit-sytile">
      <div class=" top-l">
          <div class="ft">
            <p><slot></slot></p>
          </div> 
          <div class="rl ft" >
            <p class="items">{{cardItem.add_time| formatTimestamp(1)}}</p>
            <p>订单号：{{cardItem.oid}}</p>
            <p class="lisd" v-if="userInfo.type==3">{{cardItem.hotel_title}}</p>
            <p class="cardItem ml-3 color-dle">团号：{{cardItem.title}}</p>
            <p class="ml-3 color-dle" v-if="cardItem.travel_title&&storeInfo.type!=3&&cardItem.hotel_title!=''">采购商：{{cardItem.travel_title}}</p>
            <p class="ml-2 color-dle nlis" v-if="cardItem.travel_title&&storeInfo.type!=3&&cardItem.hotel_title!=''">{{cardItem.send_type==3?'确认人':'发单人'}}：{{cardItem.send_name}}</p>
            <p class="ml-1 color-dle nlis" v-if="cardItem.travel_title&&storeInfo.type!=3&&cardItem.hotel_title!=''">手机号：{{cardItem.send_mobile}}</p>
          </div>
          <div class="rl clil" >
             <p v-if="orderStatus=='66'" @click="reduction(storeInfo.type==3?cardItem.hoid:cardItem.oid)">还原订单</p>
            <template v-for="(item,index) in travel" >
              <div class="straveln"  :key="index" v-if="showCommentBtn(item.type)&&cardItem.offer_status!=0&&!isGroup">
                <i v-if="storeInfo.type==99" class="quan">{{item.name}}</i>
                <el-tooltip class="item" content="编辑标记信息,仅自己可见" placement="bottom">
                  <span v-if="userInfo.type==3">
                      <i v-if="!$GFUN.isInArray([1],cardItem.offer_status)&&!$GFUN.isInArray([99,97],cardItem.offer_status)||cardItem.hotel_flag!=0" class="el-icon-s-flag" :class="flagson(item.type)" @click="$emit('getOrderFlag',cardItem,item.type)"></i> 
                  </span>
                  <span v-if="userInfo.type==2||storeInfo.type==99">
                      <i  class="el-icon-s-flag" :class="flagson(item.type)" @click="$emit('getOrderFlag',cardItem,item.type)"></i> 
                  </span>
                </el-tooltip>
              </div>
            </template>
              <el-tooltip class="item"  content="删除订单" placement="bottom" v-if="!isGroup">
                <span>
                  <i 
                  class="el-icon-delete-solid delete"
                  @click="DelOrderHotel(storeInfo.type==2?cardItem.oid:cardItem.hoid)" v-if="$GFUN.isInArray([9,99,97],cardItem.status||cardItem.offer_status)&&storeInfo.type!=99">
                  </i>
              </span>
            </el-tooltip>
          </div>
          <div class="rl clil mt-pi"  v-if="storeInfo.type===99&&$GFUN.isInArray([3,4],cardItem.status)">
            <el-button class="ml-2 " size="mini" type="success"  @click="$router.push({name:'OrderMatchResult',query:{orderId:cardItem.oid,storeType:3}});">查看匹配</el-button>
          </div>
          <div class="rl clil mt-pi"  v-if="cardItem.send_receipt||cardItem.offer_receipt">
              <el-popover
                v-if="cardItem.send_receipt&&cardItem.offer_receipt"
                placement="top-start"
                trigger="hover"
                >
                <ul class="invoiceClass">
                  <li @click="uploadInvoice({receipt:cardItem.send_receipt,type:2,item:cardItem})"><span>旅行社发票</span> <i class="el-icon-arrow-right"></i></li>
                  <li @click="uploadInvoice({receipt:cardItem.offer_receipt,type:3,item:cardItem})"><span>酒店发票</span> <i class="el-icon-arrow-right"></i></li>
                </ul>
                <div class="mr-2 cursor-fapiaoguanli" slot="reference">
                    <i class="iconfont icon-fapiaoguanli"></i>
                </div>
                <!-- <el-button class="ml-2 " size="mini" slot="reference">查看发票</el-button> -->
            </el-popover>
            <div class="mr-2 cursor-fapiaoguanli" v-else @click="uploadInvoice({receipt:cardItem.send_receipt||cardItem.offer_receipt,type:cardItem.send_receipt?2:3,item:cardItem})">
              <el-tooltip class="item" effect="dark" content="查看发票" placement="bottom">
                <i class="iconfont icon-fapiaoguanli"></i>
              </el-tooltip>
            </div>
            <!-- <el-button class="ml-2 " size="mini" @click="uploadInvoice({receipt:cardItem.send_receipt||cardItem.offer_receipt,type:cardItem.send_receipt?2:3,item:cardItem})" v-else>查看发票</el-button> -->
          </div>
          <div class="rl clil mt-pi"  v-if="paymentDisplay(cardItem,1)">
            <el-button class="ml-2 " size="mini" type="primary"   v-if="paymentDisplay(cardItem,2)&&cardItem.edit_status!=1" @click="finance=true;oid=cardItem.oid;price_pay=cardItem.price_pay;">提交财务</el-button>
            <el-button class="ml-2 " size="mini" type="danger"    v-if="cardItem.pay_flag_hotel==1" @click="PayReminder()">平台待打款</el-button>
            <el-button class="ml-2 " size="mini" type="success"   v-if="cardItem.pay_flag_hotel==2" @click="handleCommand(cardItem)">平台已打款</el-button>
          </div>
      </div>
      <ul class="list-item">
        <li class=" title-w" :class="cardItem.pay_arr?'w-20':'w-30'">
            <div class="title">
              <!-- <p class="cardItem">{{cardItem.title}}</p> -->
              <div class="hotels">
                <img v-lazy="$GFUN.formatImgSrc(cardItem.hotel_top_pic,64,64)" class="hotel-img cursor-pointer"  :key="cardItem.hotel_top_pic" v-if="cardItem.hotel_title!=''&&storeInfo.type!=3" @click="goHotelDetail(cardItem)">
                <img  :src="storeInfo.type==2?'/images/public/noneimg.jpg':'/images/public/logo.png'" style="width: 64px;height: 64px" class="hotel-img" v-else>
                <div class="offer_names">
                    <p @click="goHotelDetail(cardItem)" class="cursor-pointer">{{storeInfo.type==3||cardItem.hotel_title==''?cardItem.travel_title:cardItem.hotel_title}}</p>
                    <div class="text-names" v-if="(cardItem.offer_name!=''&&storeInfo.type==2)||isAdmin&&cardItem.offer_name&&cardItem.offer_name!=''">
                        <p>{{cardItem.send_type==3?'发单人':'销售'}}：{{ cardItem.offer_name }}</p>
                        <p>手机号:{{ cardItem.offer_mobile }}</p>
                    </div>
                    <div class="text-names" v-if="(cardItem.send_name&&cardItem.send_name!=''&&storeInfo.type==3)||isAdmin&&cardItem.offer_name==''&&cardItem.appoint_store_id*1==0">
                        <p>发单人: {{ cardItem.send_name }}</p>
                        <p>手机号: {{ cardItem.send_mobile }}</p>
                    </div>
                </div>
              </div>
            </div>
        </li>
        <li class="w-10 type">
            <p v-if="cardItem.appoint_store_id*1>0" class="Orange dingx">{{cardItem.ask_type==1?'确认单':'定向'}} <span>{{cardItem.city_name}}</span></p>
            <p v-else>{{cardItem.city_name}}</p>
            <p>{{cardItem.order_type==1?'住宿订单':'纯会议订单'}}</p>
            <p>{{cardItem.team_type==1?'旅游团':'会议团'}}</p>
        </li>
        <li class="w-30 date_in">
            <div v-if="cardItem.order_type==1" class="lisd">
              <div class="time">
                <p><i>入：</i><span>{{cardItem.date_in | formatTimestamp(2)}}</span></p>
                <p><i>离：</i><span>{{cardItem.date_out | formatTimestamp(2)}}</span></p>
              </div>
              <div class="time ml-2">
                <p>
                  <i v-if="cardItem.order_type==1">{{cardItem.num}}人</i>
                </p>
                <p>
                  <i>共{{((cardItem.date_out - cardItem.date_in)/86400).toFixed(0)}}晚</i>
                </p>
              </div>
              <div class="needarr" v-if="cardItem.room_need_arr.mode==0">
                <template v-for="(item,index) in cardItem.room_need_arr.list">
                  <div  :key="index" v-if="item.room_num!=0&&index<3" class="lens">
                    <span>{{item.type | formatVar('roomStyle')}}</span>
                    <span class=" nst red"  v-if="$GFUN.isInArray([7,8,9],cardItem.status||cardItem.offer_status)">¥{{item.offer_price}}</span>
                    <span v-if="!$GFUN.isInArray([7,8,9],cardItem.status||cardItem.offer_status)">{{item.room_num}}间</span>
                    <span  v-else>{{cardItem.breakfast_type | formatVar('breakfastArr')}}</span>
                  </div>
                </template>
                <span  class="liesq" v-if="cardItem.need_mode==1?cardItem.room_need_arr[0].offer_info.length>=3:cardItem.room_need_arr.length>3">...</span>
              </div>
              <div class="needarr" v-else >
                <table align="center" cellpadding="10" cellspacing="5">
                  <template v-for="(item,index) in cardItem.room_need_arr.list">
                    <tbody  :key="index" v-if="index<1">
                      <template v-for="(name,ins) in item.offer_info">
                        <tr  :key="name.id" v-if="ins<3">
                            <!-- <td >{{ins==0?item.date :''| formatTimestamp(2)}}</td> -->
                            <td >{{name.type| formatVar('roomStyle')}}</td>
                            <td>{{name.offer_title}}</td>
                            <td >{{name.room_num}}间</td>
                            <td  class="red" v-if="name.offer_price>0">¥{{name.offer_price}}</td>
                        </tr>
                      </template>
                      <span  class="liesq liet" v-if="item.offer_info.length>2">...</span>
                    </tbody>
                  </template>
                </table>
                
              </div>
              <!-- <div class="needarr nonlr " v-if="$GFUN.isInArray([7,8,9],cardItem.status||cardItem.offer_status)">
               <span class="red">¥{{cardItem.price}}</span>
              </div> -->
            </div>
            <div v-if="cardItem.order_type==2" class="lisd">
              <table align="center" cellpadding="10" cellspacing="5">
                  <tbody v-for="(item,index) in cardItem.meeting_need_arr.list" :key="index">
                    <tr>
                      <td>{{item.date | formatTimestamp(2)}}</td>
                      <td>{{item.timeslot| formatVar('TimeSlots')}}</td>
                      <td>{{item.type | formatVar('LayoutTypes')}}</td>
                      <td  class="red" v-if="$GFUN.isInArray([7,8,9],cardItem.status||cardItem.offer_status)">¥{{item.offer_price}}</td>
                      <td v-else>{{item.num}}人</td>
                      <td >{{item.area}}㎡</td>
                    </tr>
                  </tbody>
              </table>
              <!-- <div class="needarr nonlr" v-if="$GFUN.isInArray([7,8,9],cardItem.status||cardItem.offer_status)">
                <span class="red">¥{{cardItem.price}}</span>
              </div> -->
            </div>
        </li>
        <li class="w-10 center"  v-if="cardItem.verify_arr">
          <template  v-for="(item,index) in cardItem.verify_arr">
            <span :key="item.guide_id" class="verify_arr liesq" v-if="index<2">
              <span class="verify_arrFlag">{{item.flag==1?'导游：':'领队：'}}{{item.title}}</span>
              <span class="verify_arrTitle">{{item.mob}}</span>
            </span>
          </template>
          <span v-if="cardItem.verify_arr&&cardItem.verify_arr.length>=3" class="liesq">...</span>
          <span v-if="cardItem.verify_arr&&cardItem.verify_arr.length==0">未添加</span>
        </li>
        <li class="w-10 center"  v-if="cardItem.pay_arr">
          <template  v-for="(item,index) in cardItem.pay_arr">
            <span :key="item.guide_id" class="verify_arr liesq" v-if="index<2">
              <span class="verify_arrFlag">{{item.flag | formatVar('PayerPeople')}}：{{item.title}}</span>
              <span class="verify_arrTitle">{{item.mob}}</span>
            </span>
          </template>
          <span v-if="cardItem.pay_arr&&cardItem.pay_arr.length>=3" class="liesq">...</span>
          <span v-if="cardItem.pay_arr&&cardItem.pay_arr.length==0">未添加</span>
        </li>
        <li class="w-10 type" :class="!cardItem.verify_arr?'w-15':'w-10'">
          <span :class="[$GFUN.FormatColor(cardItem.status||cardItem.offer_status)]" class="liqns">
            <span v-if="cardItem.ask_type==1&&cardItem.status==99&&cardItem.deal_time==0">确认结束</span>
            <span v-else-if="cardItem.status==99||cardItem.offer_status==99">{{cardItem.deal_time>0?'取消':'询价结束'}}</span>
            <span v-else>{{(cardItem.status||cardItem.offer_status)|formatVar(orderStatusArr )}}</span>
            <span ></span>
          </span>
          <!--取消原因-->
          <div class="cancel-reason" v-if="cardItem.status==99">( {{cardItem.cancel_remark}} )</div>
          <div v-show="cardItem.offer_count>0" v-if="cardItem.status==4"><span class="text-danger">{{cardItem.offer_count}}</span> 家酒店报价</div>
          <div>
          <div class="manage-prompts" v-if="cardItem.edit_status==1||cardItem.cancel_status==1">
            <span v-if="isAdmin">{{cardItem.edit_launch_uid==cardItem.offer_uid?cardItem.offer_name:cardItem.send_name}} 发起{{cardItem.cancel_status==1?'取消':'修改'}}</span>
            <span v-else> {{ cardItem.edit_launch_uid==userLoginMessage.uid?storeInfo.type==2?cardItem.send_name:cardItem.offer_name:storeInfo.type==2?cardItem.offer_name:cardItem.send_name}} 发起{{cardItem.cancel_status==1?'取消':'修改'}}</span>
          </div>
          </div>
          <div v-if="cardItem.edit_status==1||cardItem.cancel_status==1" class="mt-22 cursor-pointer" @click.stop="$emit('goForDetail',cardItem)"  ><span class="links ml-2 ">
              待处理<a>1</a></span>
          </div>
          <!-- <div v-if="cardItem.broker>0&&storeInfo.type!=3" class="mt-22"><span class=" ml-2 ">(代订收款)</span></div> -->
          <ul  class="price_pay mt-1" v-if="cardItem.price_pay>0">
            <li v-if="cardItem.broker==0||storeInfo.type==3">
              <p>{{storeInfo.type==3?'已收款':'已支付'}}：</p>
              <p class="qls fw" :class="cardItem.price_pay/100>cardItem.price&&cardItem.broker>0&&$GFUN.isInArray([2,99],storeInfo.type)?'':'text-green'">¥{{cardItem.price_pay/100>cardItem.price&&cardItem.broker>0?cardItem.price:cardItem.price_pay/100}}</p>
            </li>
            <li v-else>
              <p>已收款：</p>
              <p class="text-green fw">¥{{cardItem.price_pay/100}}</p>
            </li>
            <li v-if="cardItem.offset_pay>0">
              <p>{{storeInfo.type==3?'待收款':'未支付'}}：</p>
              <p class="red fw">¥{{cardItem.offset_pay/100}}</p>
            </li>
          </ul>
          <!-- <div v-if="cardItem.price_pay&&cardItem.price_pay!=0&&storeInfo.type==2" class="money-Recors"><p>已支付{{cardItem.broker==1?'(代订收款):':':'}}：</p><span class="fw text-green">¥{{cardItem.price_pay/100}}</span></div>
          <div  class="money-Recors"><p>已收款：</p><span class="fw text-green">¥200</span></div>
          <div v-if="cardItem.offset_pay&&cardItem.offset_pay!=0" class="money-Recors"><p>{{storeInfo.type==2?'待付款：':'待收款：'}}</p><span class="fw red">¥{{cardItem.offset_pay/100}}</span></div> -->
        </li>
        <li class="w-10 center" :class="!cardItem.verify_arr?'w-15':'w-10'">
          <span class="text-link" @click.stop="$emit('goForDetail',cardItem)">
            订单详情
          </span>
        </li>
      </ul>
        <el-dialog title="打款回单" :visible.sync="dialogFormVisible" width="1400px" class="paymentist" >
            <Receipt :receiptInfo="receiptInfo"></Receipt>
        </el-dialog>
        <el-dialog title="提交财务" :visible.sync="finance" width="340px" class="paymentist" :close-on-click-modal="false" top="16%">
            <commission v-if="finance" @finance="finance=!finance" :oid="oid" :price_pay="financeprice(cardItem)" @submitFinance="submitFinance"></commission>
        </el-dialog>
        <!--上传发票-->
        <OrderuploadInvoice :invoiceType="invoiceType" :onShow="uploadInvoiceShow" :editMode="editMode||isAdmin" :orderDetail="orderDetail" @isClick="isClick=false"  :existImgs="existImgs" @onShow="uploadInvoiceShow=!uploadInvoiceShow" @getorderDetail="$emit('getOrderList',true)" />
    </div>
</template>
<script>
import Temp from '@/views/Admin/FinancialManage/FinancialStats/EchartStat/temp.vue'
  import { mapGetters, mapState,mapActions } from 'vuex'
  import Receipt from '../../Admin/FinancialManage/FinancialStats/Receipt.vue'
  import commission from '../../Admin/FinancialManage/Subassembly/commission.vue'
  import OrderuploadInvoice from '@/views/Order/OrderDetail/HotelOrder/Components/OrderuploadInvoice'; //上传发票弹窗
export default {
  name: 'HotelOrderCard',
  data() {
    return {
        breakfastArr:[
        {name:'delete',id:0},
        {name:'red',id:1},
        {name:'Orange',id:2},
        {name:'green',id:3},
        {name:'greys',id:4},
        {name:'purple',id:5}
      ],
      travel:[
        {name:'管',type:99},
        {name:'旅',type:2},
        {name:'酒',type:3},
      ],
      receiptInfo:{},
      dialogFormVisible:false,
      finance:false,              //提交财务
      oid:'',
      price_pay:'',
      uploadInvoiceShow:false,                     //上传发票弹窗
      editMode:false,                              //是否编辑发票
      existImgs:'',                                //已存在发票
      isClick:false,                                //禁止连续点击
      invoiceType:'',                               //发票点击的身份值
      orderDetail:{},
    }
  },
  props: {
    cardItem: {},
    orderStatus:'',
    state:1,
    orderConfirm:false,
  },
  mounted() {
    // this.cardItem.room_need=JSON.parse(this.cardItem.room_need);
  },
  components: { Receipt,commission, Temp,OrderuploadInvoice},
  computed: {
    ...mapState(['currentStoreInfo','newMessageInform','userLoginMessage']),
    ...mapGetters(['storeInfo','userInfo','isGroup','isAdmin']),
    orderStatusArr() {
      switch (this.storeInfo.type) {
        case 99:
        case 2: return 'TOrderStatus';
        case 3: return 'HOrderStatus';
        default:return '';
      }
    },
  },
  watch: {
    newMessageInform(newVal) {
      //收到通知刷新当前页面
      if (newVal && this.$GFUN.isInArray([39,40,42,43],newVal.type)){
      this.$emit('getOrderList',true)
      }
    }
  },
  methods: {
    ...mapActions(['cancellationDelOrderHotel','searchOrder','restoreOrder','adminSubmitFinance','adminPaymentInfor','getWaitHandleData']),
    /*显示标注按钮*/
    showCommentBtn (e) {
      let t = this.storeInfo.type;
      if(t=='99'){
        return true
      }else{
        if(e==t) return true
      }
    },
    flagson(n) {
    let {cardItem,breakfastArr}=this;
      switch (n) {
        case 99: return breakfastArr[cardItem.admin_flag||0].name;
        case 2:  return breakfastArr[cardItem.travel_flag||0].name;
        case 3:  return breakfastArr[cardItem.hotel_flag||0].name;
      }
    },
    //查看回执单
    handleCommand(Itemize) {
          this.adminPaymentInfor({
              data:{pay_id:Itemize.pay_id_hotel},
              successFun: (res) => {
                  this.receiptInfo=res;
                  this.dialogFormVisible=true;
              }
          })
    },
    /**
     * 还原订单
     */
    reduction(e){
      this._confirm('确定要还原该订单吗？',() => {
          this.restoreOrder({
            oid:e,
            orderStatus:this.orderStatus,
            successFun: () => {
                this.$emit('getOrderList',true)
                this._alert('还原订单成功');
            }
          });
      });
    },
    // 酒店详情页
    goHotelDetail (cardItem) {
      if (this.isAdmin&& this.$GFUN.isInArray([99],this.storeInfo.type)){
        let routeUrl = this.$router.resolve({name:'StoreDetail',query:{id:cardItem.appoint_store_id,type:'3',none:1}});
        window.open(routeUrl.href, '_blank');
      }else{
        let changeRoute = this.$router.resolve('/index_hotel/hotel_detail/'  + cardItem.appoint_store_id);
        window.open(changeRoute.href, '_blank');
      }
    },
    /**
     * 管理员提交财务
     */
    submitFinance(ruleForm){
          this.finance=!this.finance
          this.adminSubmitFinance({
            type:3,
            data:ruleForm,
            successFun: () => {
                this.$emit('getOrderList',true);
                this.getWaitHandleData();
                this._alert('已提交财务，可在待打款列表中查看');
            }
          });
    },
    /**
     * 管理员判断订单显示提交财务条件
     */
    paymentDisplay(cardItem,i){
      let status=this.$GFUN.isInArray([7,8,9],cardItem.status||cardItem.offer_status);
      let type=this.$GFUN.isInArray([3,99],this.storeInfo.type);
      let price=(cardItem.price_pay+cardItem.offline_pay)>=cardItem.price*100&&this.$GFUN.isInArray([99],this.storeInfo.type)&&cardItem.price_pay>0&&cardItem.pay_flag_hotel==0;
      if(i == 1){return status&&type;}
      if(i == 2){return price}
    },
    /**
     * 代打款提示
     */
    PayReminder(){
        this._alert('平台打款处理中，请耐心等待');
    },
    /**
     * 删除订单
     */
    DelOrderHotel(e){
      this._confirm(this.orderStatus==66?'永久删除后，您将无法再查看该订单!':'确实要删除该订单吗？',() => {
          this.cancellationDelOrderHotel({
            oid:e,
            orderStatus:this.orderStatus,
            successFun: () => {
                this.$emit('getOrderList',true);
                this._alert('删除订单成功');
            }
          });
      });
    },
    /**
   * 手续费最大值
   */
    financeprice(res){
      let price=0,price_pay=res.price_pay/100;
      if(res.price<price_pay){
        price=res.price
      }else{
        price=price_pay
      }
      return price
    },
    //开始上传发票
    uploadInvoice(e){
      let editMode=this.isAdmin?true:e.type==this.storeInfo.type;
      if(!this.isClick){
        console.log(editMode);
        this.invoiceType=e.type;
        this.editMode=editMode;
        if(this.existImgs===e.receipt||e.receipt==''){
          this.uploadInvoiceShow=true ;
          return;
        }
        this.orderDetail=e.item;
        this.isClick=true;
        this.existImgs=e.receipt;
      } 
    },
  },
}
</script>

<style scoped>
    .order-bottom-make{
        background-color: #00cea7;
        color: #fff;
        padding: 3px 6px;
        font-size: 10px;
        margin-left: 6px;
        border-radius: 2px;
        display: block;
  }
  .money-Recors{
    display: flex;
    justify-content: center;
  }
  .money-Recors .fw{
    font-weight: bold;
    font-size: 15px;
  } 

  .liesq{
    text-align: left !important;
    width: 68% !important;
    margin-left: 30% !important;
    margin: 0 auto;
  }
   .liesq span{
       white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      display: block;
      text-align: left !important;
      width: 100% !important;
   }
  .verify_arr .verify_arrFlag{
    text-align: center;
    width: 24%;
    font-size: 12px;
  }
  .verify_arr .verify_arrTitle{
    font-size: 12px;
    display: block;
    margin-top: 4px;
  }
  .verify_arr{
    overflow: hidden;
    padding: 4px 0;
    width: 94%;
    margin-left: 3%;

  }
  table {
    border-collapse: collapse;
  }
  .hotels{
    margin-top: 12px;
    display: flex;
    justify-content: left;
    width: 96%;
  }
  .hotels p{
    display: flex;
    justify-content: center;
    flex-direction: column;
  }
  .lisd{
    display: flex;
    justify-content:center;
  }
  .lisd th,.lisd td{
    padding: 4px 10px;
    font-size: 12px;
  }
  .needarr{
    float: left;
    display:flex;
    justify-content: center;
    flex-direction: column;
    min-height: 60px;
    margin-left: 20px;
  }
  .needarr span{
    display: block;
    float: left;
    width: 50px;
    margin-top: 2px;
  }
  .lsit-sytile{
    border: 1px #94c9fb solid;
    background-color: #fff;
    margin-top: 20px;
  }
  .rl{
    float: right;
  }
  .rl p{
    float: left;
    font-size: 14px;
    margin-top: -2px;
  }
  .rl i{
    font-size: 16px;
    margin-left: 10px;
    cursor: pointer;
    margin-top: 1.5px;
  }
  .list-item{
    width: 100%;
    text-align: left;
    color: #333;
  }
  .list-item>li{
    padding: 20px 0;
  }
  .top-l{
    border-bottom: 1px #94c9fb solid;
    padding: 10px 20px;
    padding-bottom: 5px;
    overflow: hidden;
  }
  .top-l .ft{
    float: left;
  }
  .top-l .ft p{
    float: left;
    color: #999;
    margin-right: 12px;
  }
  .top-l .ft .lisd{
    font-weight: bold;
    color: #333;
  }
  .title span{
      margin-right: 8px;
      color: #333;
  }
  .type{
    text-align: center;
    border-right:1px #eee solid;
    border-left: 1px #eee solid;
    display:flex;
    justify-content: center;
    flex-direction: column;
  }
  .type p:nth-child(1){
    margin-top: 0;
  }
  .type p{
    margin-top: 12px;
  }
  .date_in{
    border: 1px #eee solid;
        display: flex;
    justify-content: center;
    flex-direction: column;
  }
  .date_in .time{
    text-align: center;
    float: left;
    display: flex;
    justify-content: center;
    flex-direction: column;
  }
  .date_in .time p{
    margin-top: 12px;
  }
  .date_in .time p:nth-child(1){
    margin-top: 0px;
  }
  .date_in .time p span{
    color: #60c9fd; 
  }
  .center{
    text-align: center;
        display: flex;
    justify-content: center;
    flex-direction: column;
  }
  .title{
    margin-left: 20px;
    margin-bottom: 14px;
    color: #333;
    cursor: initial;
  }
  .title p{
    font-weight: normal;
  }
  .title .cardItem{
    font-size: 16px;
    font-weight: normal;
  }
  .clil{
    cursor: pointer;
  }
  /* .rl p{
    cursor: pointer;
  } */
  .rl .items{
    margin-top: 0px;
    line-height: 20px;
  }
  .straveln{
    float: left;
  }
  .straveln .quan{
    font-style: normal;
    color: #666;
    border: 1px #666 solid;
    font-size: 14px;
    border-radius: 50px;
    padding: 2px 3px;
  }
  .lens{
    display: flex;
    line-height: 20px;
  }
  .lens .nst{
    margin-top: 3px;
  }
  .nonlr{
    margin-left: 0;
    text-align: center;
  }
  .hotel-img{
    width: 64px;
    height: 64px;
  }
  .ren{
    font-weight: bold;
  }
  .dingx{
    font-size: 17px;
  }
  .dingx span{
    font-size: 14px;
    color: #333;
  }
  .time i{
    font-weight: bold;
    font-style: normal;
    color: #555;
  }
  .liqns{
    font-size: 14px;
    font-weight: bold;
  }
  .mt-22{
    margin-top: 4px;
    position: relative;
  }
  .mt-22 span{
    position: relative;
  }
  .mt-22 a{
    font-size: 10px;
    padding: 2px 5px;
    border-radius: 50px;
    background-color: red;
    color: #fff;
    top: -5px;
    right: -14px;
    position: absolute;
  }
  .links{
    color: var(--smtc-color-primary); 
  }
  .liet{
    margin-left: 48% !important;
  }
  .text-darkBlue{
    color: #1569bf;
  }
  .title-w{
    display: flex;
    justify-content: center;
    flex-direction: column;
  }
  .price_pay{
    overflow: hidden;
    width: 100%;
  }
  .price_pay li{
    width: 100%;
    display: flex;
    justify-content: center;
  }
  .price_pay li p{
    margin-top:auto;
  }
  .price_pay li p:nth-child(1){
    text-align: right;
    width: 60%;
  }
  .price_pay li p:nth-child(2){
    width: 40%;
    text-align: left;
  }
  .redblie{
      background-color: red;
  }
  .color-dle{
    color: #333 !important;
  }
  .qls{
    color: #666;
  }
  .fw{
    font-weight: bold;
  }
  .offer_names{
    margin-left: 15px;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .text-names p{
    display: block;
    font-size: 12px;
    color: #666;
  }
  .text-names p:nth-child(1){
    margin-top: 4px;
  }
  .nlis{
    font-size: 12px !important;
    line-height: 24px;
    color: #666 !important;
  }
  .invoiceClass li{
    display: flex;
    justify-content:space-between;
    padding: 6px 0;
    cursor: pointer;
  }
  .invoiceClass li span{
    font-size: 12px;
    font-weight: bold;
  }
   .invoiceClass li i{
    color: #999;
    font-size: 12px;
    margin-top: 2px;
   }
   .manage-prompts{
    color: #999;
    margin-top: 4px;
   }
   .cancel-reason{
    font-size: 12px;
    color: #999;
    margin-top: 6px;
   }
   .cursor-fapiaoguanli{
    margin-top: -2px;
    position: relative;
   }
   .cursor-fapiaoguanli::after{
    content: '';
    position: absolute;
    top: 0;
    right: -8px;
    width: 1px;
    height: 100%;
    background-color: #999;
    border-radius: 50%;
    opacity: 0.2; 
   }
   .icon-fapiaoguanli{
    font-size: 26px !important;
    color:var(--smtc-color-primary);
   }
</style>